@if (loginStateService.loggedIn()) {
  <div id="search-holder">
    <form (submit)="router.navigate(['/search/' + query])">
      <input type="search" id="search-input" name="query" placeholder="{{stringService.strings['SEARCH']}}" [(ngModel)]="query" />
    </form>
  </div>
  <div id="new-employee-holder">
    <div id="new-employee" (click)="router.navigate(['/employee'])">+</div>
  </div>
  @if (loading) {
    <img src="assets/img/loading.gif" class="loading">
  }
}

@if (auth.role.role === 'BROKER_HR' || auth.role.role === 'BROKER_WRITE') {
  <div id="extra-functions-holder">
    <div id="generate-phonebook" (click)="generatePhonebook()"><img src="assets/img/phone-book.png" /></div>
  </div>
}
